import { Button } from "antd";
import React, { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import CreateProfileCardWrapper from "../../components/common/CreateProfileCardWrapper";
import CreateProfileCenterWrapper from "../../components/common/CreateProfileCenterWrapper";
import {
  setAnsweredQuestions,
  setInnerStepper,
  setStepperStatus,
  setTotalQuestions,
} from "../../redux/slices/common_slice";
import { setUserFormData } from "../../redux/slices/form_slice";
import { routePaths } from "../../routing/routePaths";
import "./OnboardingPage.css";
const FinalSteps = ({ formik, onFinish }) => {
  const isMobile = window.innerWidth < 768;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const containerRef = useRef();
  const stepperStatus = useSelector((state) => state.common?.stepperStatus);
  const { t } = useTranslation();
  useEffect(() => {
    if (containerRef) {
      containerRef.current.scrollTo({
        behavior: "smooth",
        block: "start",
        inline: "nearest",
      });
      window.scrollTo({ top: 0 });
    }
  }, [containerRef]);

  return (
    <div className="onboarding-container" ref={containerRef}>
      <div className="onboarding-page no-scroll final-page-no-bg">
        <CreateProfileCenterWrapper className="is-final">
          <div className="row mx-0 phase-2-complete-row position-relative">
            <div className="successful-video-tag">
              <img
                alt=""
                src="/assets/images/icons/phase-completion-icon.svg"
                className="completion-icon"
              />
              <img
                src={
                  isMobile
                    ? "/assets/gifs/mobile-celeb.gif"
                    : "/assets/gifs/web-celeb.gif"
                }
                alt="img-fluid"
                className="completion-gif"
              />
            </div>
            <div className="col-12 successful-tag-inner">
              <h1 className="mb-1">{t("aboutYou.phase1.success")}</h1>
              <h6 className="mb-1">{t("aboutYou.phase1.headline1")}</h6>
              <h6 className="mb-1">{t("aboutYou.phase1.headline2")}</h6>
            </div>
          </div>
          <CreateProfileCardWrapper>
            <h2>{t("aboutYou.phase1.content.title")}</h2>
            <h3>{t("aboutYou.phase1.content.subTitle1")}</h3>
            <h4>
              {t("aboutYou.phase1.content.p1")}
              <br />
              <br />
              {t("aboutYou.phase1.content.p2")}
              <br />
              <br />
              {t("aboutYou.phase1.content.p3")}
              <br />
              <br />
              {t("aboutYou.phase1.content.p4")}
            </h4>
            <br />
            <h3>{t("aboutYou.phase1.content.subTitle2")}</h3>
            <h4>
              {t("aboutYou.phase1.content.p5")}
              <br />
              <br />
              {t("aboutYou.phase1.content.p6")}
              <br />
              <br />
              {t("aboutYou.phase1.content.p7")}
            </h4>
            <br />
            <h3>{t("aboutYou.phase1.content.subTitle3")}</h3>
            <h4>
              {t("aboutYou.phase1.content.p8")}
              <br />
              <br />
              {t("aboutYou.phase1.content.p9")}
            </h4>
            <Button
              className="auth-theme-btn process-with-phase-btn"
              onClick={() => {
                onFinish();
                dispatch(
                  setStepperStatus({
                    ...stepperStatus,
                    isProfileCompleted: true,
                  })
                );
                navigate(routePaths.income);
                dispatch(setTotalQuestions(8));
                dispatch(setAnsweredQuestions(0));
                dispatch(setInnerStepper(0));
                dispatch(setUserFormData(formik.values));
              }}
            >
              {t("aboutYou.proceedBtn")}
            </Button>
          </CreateProfileCardWrapper>
        </CreateProfileCenterWrapper>
      </div>
    </div>
  );
};

export default FinalSteps;
